module.exports = __webpack_public_path__ + "img/SCC_Treg.e0b9595e.png";